import { jwtDecode } from 'jwt-decode';
import { IJwtPayload, JwtPayload } from '../interfaces';

export function decodeToken(token: string): IJwtPayload {
  if (token) {
    const decoded = jwtDecode<JwtPayload>(token);
    return decoded.payload;
  }
  return {} as IJwtPayload;
}
